import { Link } from "react-router-dom";
import { toast } from "sonner";
import { FileDown, FileText, Printer } from "lucide-react";
import { api } from "@/lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const usd = (c) => `$${(c / 100).toFixed(2)}`;

export async function downloadFile(path, filename, what = "PDF") {
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    Object.assign(document.createElement("a"), { href: url, download: filename }).click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch {
    toast.error(`Couldn't make the ${what}`);
  }
}

export const downloadStatement = (id) => downloadFile(`/payouts/${id}/pdf`, `pay-statement-${id.slice(0, 8)}.pdf`);

// "Statement" menu on a payment: download a PDF or open the printable page.
export default function StatementMenu({ id, testid }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="inline-flex items-center gap-1 rounded-full border border-slate-200 px-2 py-0.5 text-[11px] font-semibold text-slate-700 hover:bg-slate-50" data-testid={testid}>
        <FileText className="h-3 w-3" /> Statement
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={() => downloadStatement(id)} data-testid={`${testid}-pdf`}><FileDown className="mr-2 h-3.5 w-3.5" /> Download PDF</DropdownMenuItem>
        <DropdownMenuItem asChild data-testid={`${testid}-print`}>
          <Link to={`/pay-statement/${id}`} target="_blank" rel="noopener"><Printer className="mr-2 h-3.5 w-3.5" /> Printable page</Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
